/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconChevronsUpRight = createReactComponent("outline", "chevrons-up-right", "IconChevronsUpRight", [["path", { "d": "M9 7h8v8", "key": "svg-0" }], ["path", { "d": "M5 11h8v8", "key": "svg-1" }]]);

export { IconChevronsUpRight as default };
//# sourceMappingURL=IconChevronsUpRight.mjs.map
